import { LangText } from '@/components';
import { preFixImgUrl } from '@/utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { SearchOutlined, UserOutlined, DownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';

export default function Home() {
  const bannerList = [
    {
      img: preFixImgUrl('906d4e843bb5820a40633c73b853babb.png'),
    },
    {
      img: preFixImgUrl('3be2ab44658c1c52910d76775cabc1c5.png'),
    },
    {
      img: preFixImgUrl('d22ea12752a74ebc180cbaa7127ade55.png'),
    }
  ];

  const navigate = useNavigate();

  const categories = [
    { key: 'a1b2c3d4', text: '温泉', icon: preFixImgUrl('04fd7c6bfdc050d2de376eb693163593.png') },
    { key: 'b2c3d4e5', text: '美食', icon: preFixImgUrl('65ac59d3e71e22c47604f5fc9fdff4fd.png') },
    { key: 'c3d4e5f6', text: '购物', icon: preFixImgUrl('c797972ac9b76f066e0849d7b6e8bf5c.png') },
    { key: 'd4e5f6g7', text: '景点', icon: preFixImgUrl('9dbaa918774829206eaa2b36c29531d1.png') },
    { key: 'e5f6g7h8', text: '酒店', icon: preFixImgUrl('d9bd5c694d6e5503cbfe503328a4f3f5.png') },
    { key: 'f6g7h8i9', text: '文化', icon: preFixImgUrl('17dd4284a9352e8c4001be78bdcb9419.png') },
    { key: 'g7h8i9j0', text: '亲子', icon: preFixImgUrl('906c1e16c373b490ad1dc032e0556a1e.png') },
    { key: 'h8i9j0k1', text: '情侣', icon: preFixImgUrl('18745529d9892a4f1c14871cbbee4b66.png') },
    { key: 'i9j0k1l2', text: '野营', icon: preFixImgUrl('050bc9eb3a0552ab65ee293a6aa3f815.png') },
    { key: 'j0k1l2m3', text: '滑雪', icon: preFixImgUrl('16d712e92f1f2da64579875f5ac4daab.png') },
    { key: 'k1l2m3n4', text: '沙滩', icon: preFixImgUrl('e34ca65d097c45659f01b326935b618d.png') },
  ];

  return (
    <>
      <div className="relative -mt-20">
        {/* 背景图片轮播 - 从页面顶部开始，随页面滚动，宽度100%，高度按图片比例自适应 */}
        <div className="relative w-full">
          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true }}
            loop
            speed={1000}
            className="w-full"
          >
            {bannerList.map((item, index) => (
              <SwiperSlide key={index} className="relative w-full">
                <img
                  src={item.img}
                  alt={`Banner ${index + 1}`}
                  className="object-cover w-full h-auto"
                />
              </SwiperSlide>
            ))}
            {/* 内容区域 - 参考Banner组件，直接在SwiperSlide内部 */}
            <div className="flex absolute inset-0 z-10">
              <div className="flex flex-col justify-center px-[150px] mx-auto w-full max-w-12xl">
                {/* 大标语 - 左对齐 */}
                <div className="mt-4 mt-16 mb-20 text-left">
                  <h1 className="text-white text-[48px] font-bold leading-[1.5]">
                    もっと楽しく、もっと便利、<br />
                    もっとお得に。
                  </h1>
                </div>

                {/* AI 旅行规划师 - 左对齐 */}
                <div className="mb-8">
                  <div className="flex gap-2 items-center">
                    <div className="flex flex-shrink-0 justify-center items-center h-8">
                      <img src={preFixImgUrl('169a4c087d0b7dadbf6543f01aee5b5d.png')} alt="AI 旅行规划师" className="w-full h-full" />
                    </div>
                    <LangText lngKey="a1b2c3d4" className="text-white text-[30px] font-bold ml-2 ">
                      旅行规划师
                    </LangText>
                  </div>
                </div>

                {/* 搜索栏 - 宽度100% */}
                <div className="mb-16">
                  <div className="w-full">
                    <div className="relative rounded-[22px] p-[5px]">
                      <div 
                        className="absolute inset-0 rounded-[22px] pointer-events-none marquee-border"
                        style={{
                          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                          WebkitMaskComposite: 'xor',
                          maskComposite: 'exclude',
                          padding: '5px',
                          zIndex: 0,
                          '--angle': '0deg',
                        } as React.CSSProperties & { [key: string]: string | number }}
                      />
                      <style>{`
                        @property --angle {
                          syntax: '<angle>';
                          initial-value: 0deg;
                          inherits: false;
                        }
                        .marquee-border {
                          background: conic-gradient(from var(--angle), #ec4899, #a855f7, #3b82f6, #adff2b, #ec4899);
                          animation: marquee 3s linear infinite;
                        }
                        @keyframes marquee {
                          0% {
                            --angle: 0deg;
                          }
                          100% {
                            --angle: 360deg;
                          }
                        }
                      `}</style>
                      <div className="relative rounded-[16px] flex flex-col flex-row items-stretch items-center p-2 gap-3 bg-[rgba(102,102,101,0.9)] z-10">
                        {/* 左侧搜索 */}
                        <div className="flex flex-1 gap-3 items-center pl-4">
                          <SearchOutlined className="text-[20px] flex-shrink-0" style={{ color: '#E2E2E2' }} />
                          <input
                            type="text"
                            placeholder="你想去哪里?"
                            className="flex-1 outline-none text-white placeholder-[#E2E2E2] text-[16px] py-2 min-w-0 bg-transparent"
                          />
                        </div>

                        {/* 中间分隔线 */}
                        <div className="block hidden w-px h-10 bg-white/20"></div>

                        {/* 中间选择 */}
                        <div className="flex gap-2 items-center px-3 px-4 pt-0 mr-32 border-t-0 border-t cursor-pointer border-white/20">
                          <UserOutlined className="text-[20px] flex-shrink-0" style={{ color: '#E2E2E2' }} />
                          <span className="text-[#E2E2E2] text-[16px] whitespace-nowrap">1房间, 2成人</span>
                          <DownOutlined className="text-[14px] flex-shrink-0" style={{ color: '#E2E2E2' }} />
                        </div>

                        {/* 右侧按钮 */}
                        <button className="px-18 py-3 bg-white rounded-[22px] font-medium hover:opacity-90 transition-opacity text-[16px] whitespace-nowrap mr-2" onClick={() => navigate('/ai-trip')}>
                          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#5652FF] to-[#9C59FF]">
                            <LangText lngKey="b2c3d4e5">开始智能规划旅程!</LangText>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 热门度假类别 - 左对齐 */}
                <div className="w-full">
                  <h2 className="text-white text-[30px] font-bold text-left mb-8 leading-tight">
                    <LangText lngKey="c3d4e5f6">热门度假类别</LangText>
                  </h2>
                  
                  <div className="grid grid-cols-11 w-full">
                    {categories.map((category) => (
                      <div
                        key={category.key}
                        className="flex flex-col gap-4 items-center transition-opacity group"
                      >
                        <div className="w-[38px] h-[38px]"><img src={category.icon} alt={category.text} className="w-full h-full" /></div>
                        <LangText lngKey={category.key} className="text-white text-[18px] font-normal text-center">
                          {category.text}
                        </LangText>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Swiper>
        </div>
      </div>
      <div className="relative w-full">
        <img src={preFixImgUrl('437c0204bb14cc868b084f84efe93b87.jpg')} className="w-full h-auto" alt="服务支持" />
        
        {/* 行前购 */}
        <div
          className="absolute"
          style={{
            left: '8.8%',
            bottom: '6.7%',
            width: '13.5%',
            height: '19%',
          }}
          onClick={() => navigate('/haneda-shop')}
        />
        
        {/* 空手旅行 */}
        <div
          className="absolute"
          style={{
            left: '23.7%',
            bottom: '6.7%',
            width: '13.5%',
            height: '19%',
          }}
          onClick={() => navigate('/sagawa-exp')}
        />
        
        {/* 优惠券 */}
        <div
          className="absolute"
          style={{
            left: '38.7%',
            bottom: '6.7%',
            width: '13.5%',
            height: '19%',
          }}
          onClick={() => navigate('/coupon')}
        />
        
        {/* VIP服务 */}
        <div
          className="absolute"
          style={{
            left: '53.7%',
            bottom: '6.7%',
            width: '13.5%',
            height: '19%',
          }}
          onClick={() => navigate('/vip')}
        />
        
        {/* 交通卡 */}
        <div
          className="absolute"
          style={{
            left: '68.7%',
            bottom: '6.7%',
            width: '13.5%',
            height: '19%',
          }}
          onClick={() => {
            message.info('敬请期待');
          }}
        />
        
        {/* 退税 */}
        <div
          className="absolute"
          style={{
            left: '83.8%',
            bottom: '6.7%',
            width: '13.5%',
            height: '19%',
          }}
          onClick={() => {
            message.info('敬请期待');
          }}
        />
      </div>
      <div>
        <img src={preFixImgUrl('f6253ead599251dd0dc4772b11b751c5.jpg')} className="w-full h-full" />
      </div>
      <div>
        <img src={preFixImgUrl('aaa6c5353ac9424f53091bd91af8a12c.jpg')} className="w-full h-full" />
      </div>
      <div>
        <img src={preFixImgUrl('cc617f68c6e2db31c28f56ae85560e26.jpg')} className="w-full h-full" />
      </div>
      <div>
        <img src={preFixImgUrl('98392004f3b4475158b9e13985787946.jpg')} className="w-full h-full" />
      </div>
      <div>
        <img src={preFixImgUrl('2e3b259de1dad1fcbeced9ef7d6f8ff0.jpg')} className="w-full h-full" />
      </div>
      <div className="relative w-full">
        <img src={preFixImgUrl('7dce9f79c3033212ad3952ac9c2ce191.jpg')} className="w-full h-auto" alt="注册banner" />
        
        {/* 立即注册按钮 */}
        <div
          className="absolute transition-opacity cursor-pointer hover:opacity-80"
          style={{
            left: '53.5%',
            bottom: '51.4%',
            width: '13.8%',
            height: '6%',
          }}
          onClick={() => navigate('/signup')}
        />
      </div>
    </>

  );
}
